var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FlexBox, Spinner } from '@dixa/lib-shared-habla';
import { authApi } from 'apis/auth';
import { useAppPathParams } from 'utils/url/useAppPathParams';
import { ViewToken } from './components/viewToken/viewToken';
export const pathToApiTokensSettings = '/settings/integrations/api-tokens';
/** Page to show details for an API token. */
export const SettingsIntegrationsApiTokensTokenView = () => {
    const params = useAppPathParams('/settings/integrations/api-tokens/:id');
    const { token, isLoading } = authApi.useReadApiTokensQuery(undefined, {
        selectFromResult: (_a) => {
            var { data } = _a, rest = __rest(_a, ["data"]);
            return (Object.assign(Object.assign({}, rest), { token: data === null || data === void 0 ? void 0 : data.data.tokens.find((token) => token.id === params.id) }));
        },
    });
    return (_jsx(_Fragment, { children: isLoading ? (_jsx(FlexBox, Object.assign({ height: "100%", alignItems: "center", justifyContent: "center" }, { children: _jsx(Spinner, {}) }))) : (_jsx(ViewToken, { token: token })) }));
};
